// extracted by mini-css-extract-plugin
export default {"container":"more_container__3EdJK","icon":"more_icon__1c2eO","label":"more_label__2U_fr","purple":"more_purple__d_jtz"};